import { JSX } from "react";
import { NetworkIntegrityActionStatus, NetworkIntegrityActionStatusDisplay } from "@app/projects/network-assessment/network-integrity/filters/networkIntegrityFilterConstants";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface NetworkIntegrityActionStatusFilterProps {
  actionStatus: NetworkIntegrityActionStatus;
  setActionStatus: (value: NetworkIntegrityActionStatus) => void;
}

const NetworkIntegrityActionStatusFilter = (props: NetworkIntegrityActionStatusFilterProps): JSX.Element => {
  const { actionStatus, setActionStatus } = props;

  return (
    <QESSelect
      label="Action Status:"
      testId="network-integrity-filters__action-status"
      value={actionStatus}
      onChange={(e) => setActionStatus(e.target.value as NetworkIntegrityActionStatus)}
      className="network-integrity-filters__action-status"
    >
      {Object.values(NetworkIntegrityActionStatus).map((status) => (
        <option key={`network-integrity-filters__action-status-option--${status}`} value={status}>
          {NetworkIntegrityActionStatusDisplay[status]}
        </option>
      ))}
    </QESSelect>
  );
};

export default NetworkIntegrityActionStatusFilter;
